'use strict';

angular.module('nfseApp')
    .factory('Mongo', function ($resource) {
        return $resource('api/mongo/:id', {}, {
            'dropDb': {
                url: 'api/mongo/drop-db',
                method: 'DELETE'
            },
            'dropCollection': {
                url: 'api/mongo/drop-collection',
                method: 'DELETE'
            }
        });
    });
